import hexToRgba from "hex-rgba";
import commonTheme from "./common-theme";

const theme = {
  name: "bibino-light",
  fonts: commonTheme.fonts,
  breakpoints: commonTheme.breakpoints,
  isDarkMode: false,
  colors: {
    ...commonTheme.colors,
    primary: "#8f6df5",
    primaryLight: hexToRgba("#8f6df5", 12),
    primaryLight2: hexToRgba("#8f6df5", 24),
    primaryLighter: "#9a7cf6",
    primaryDarker: "#8162dd",
    primaryBackground: "#8f6df5",

    secondary: "#2aa598",
    secondaryLight: hexToRgba("#2aa598", 12),
    secondaryLight2: hexToRgba("#2aa598", 24),
    secondaryLighter: "#3faea2",
    secondaryDarker: "#269589",

    get highEmphasis() {
      return this.black;
    },
    get mediumEmphasis() {
      return this.black54;
    },
    get lowEmphasis() {
      return this.black38;
    },
    get outline() {
      return this.black20;
    },
    get outlineHover() {
      return this.black38;
    },
    get surface() {
      return this.white;
    },
    get surfaceElevated1() {
      return this.white;
    },
    get surfaceElevated2() {
      return this.white;
    },
    get surfaceElevated3() {
      return this.white;
    },
    get hover() {
      return this.black4;
    },
    get iconBackground() {
      return this.black8;
    },
    get overlay() {
      return this.black30;
    },

    warningBase: "#ff416f",
    warningLight: hexToRgba("#ff4f41", 12),
    warningLight2: hexToRgba("#ff4f41", 24),
    warningLighter: "#ff547d",
    warningDarker: "#e63b64",

    tint2: "#ffcc3f",
    tint2Light: hexToRgba("#ffcc3f", 12),

    // for device tab marks
    tint3: "#4285f4",
    tint3Light: hexToRgba("#4285f4", 12),
    tint4: "#9b1ff4",
    tint4Light: hexToRgba("#9b1ff4", 12),
    "command-tint2": "#f58900",
    "command-tint2Light": hexToRgba("#f58900", 16),
    "command-tint4": "#00aa9a",
    "command-tint4Light": hexToRgba("#00aa9a", 12),
    "command-tint8": "#fa48ad",
    "command-tint8Light": hexToRgba("#fa48ad", 12),

    tintRed: "#FF416F",
    tintOrange: "#F58900",
    tintYellow: "#FAB500",
    tintYellowLight: hexToRgba("FAB500", 12),
    tintOlive: "#92AD00",
    tintGreen: "#58A509",
    tintTurquoise: "#2AA598",
    tintTurquoiseLight: hexToRgba("2AA598", 12),
    tintBlue: "#4D8DF7",
    tintIndigo: "#4F5CFF",
    tintPurple: "#8f6df5",
    tintPurpleLight: hexToRgba("8f6df5", 12),
    tintPink: "#FA48AD",
    tintBrown: "#825F5F"
  }
};

export default theme;
